import { render } from "./component-egrul-date.vue?vue&type=template&id=25fc0fe8"
import script from "./component-egrul-date.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-date.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25fc0fe8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25fc0fe8', __exports__)) {
    api.reload('25fc0fe8', __exports__)
  }
  
  module.hot.accept("./component-egrul-date.vue?vue&type=template&id=25fc0fe8", () => {
    api.rerender('25fc0fe8', render)
  })

}


export default __exports__